module.exports = __webpack_public_path__ + "img/kucoin.d2183c40.png";